<template>
  <div id="page_mitraserver">
    <v-dialog v-model="dialog" persistent width="500">
      <v-card>
        <v-toolbar color="primary" dark flat dense cad>
          <v-toolbar-title class="subheading">Add New Mitra</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="closeDialog()">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-form v-model="valid" ref="form" lazy-validation>
            <v-container>
              <v-layout fluid row wrap>
                <v-flex lg12 sm12 xs12>
                  <v-text-field label="Name" name="name" v-model="addApp.name"></v-text-field>
                </v-flex>
                <v-flex lg12 sm12 xs12>
                  <v-text-field label="Address" name="version" v-model="addApp.address"></v-text-field>
                </v-flex>
                <v-flex lg6 sm12 xs12>
                  <v-text-field label="Contact" name="contact" v-model="addApp.contact"></v-text-field>
                </v-flex>
                <v-flex lg6 sm12 xs12>
                  <v-text-field label="Phone" name="phone" v-model="addApp.phone"></v-text-field>
                </v-flex>
                <v-flex lg6 sm12 xs12>
                  <v-text-field label="Email" name="email" v-model="addApp.email"></v-text-field>
                </v-flex>
                <v-flex lg6 sm12 xs12>
                  <v-text-field label="ServerID" name="server_id" v-model="addApp.server_id"></v-text-field>
                </v-flex>
                <v-flex lg6 sm12 xs12>
                  <v-select
                    label="Member Type"
                    class="pr-3"
                    item-text="text"
                    item-value="aktif"
                    v-model="addApp.member_type"
                    :items="select_member_type"
                  ></v-select>
                </v-flex>
                <v-flex lg6 sm12 xs12>
                  <v-select
                    label="Engine Core"
                    class="pr-3"
                    item-text="text"
                    item-value="aktif"
                    v-model="addApp.engine_core"
                    :items="core_engine"
                  ></v-select>
                </v-flex>

                <v-flex lg4 sm12 xs12>
                  <v-select
                    label="Status"
                    class="pr-3"
                    item-text="text"
                    item-value="aktif"
                    v-model="addApp.status"
                    :items="statuses"
                  ></v-select>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" @click="closeForm()">Cancel</v-btn>
          <v-btn color="success" @click="simpanForm(addApp)">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-flex lg12>
          <v-card>
            <v-toolbar card color="white">
              <v-text-field
                flat
                solo
                prepend-icon="search"
                placeholder="Type something"
                v-model="search"
                hide-details
                class="hidden-sm-and-down"
              ></v-text-field>
              <v-btn icon>
                <v-icon>filter_list</v-icon>
              </v-btn>
              <v-btn color="success" @click.native="openmodal()">
                <v-icon dark>add</v-icon>Add
              </v-btn>
              <v-btn color="primary" @click.native="getmitra()">
                <v-icon dark>refresh</v-icon>Refresh
              </v-btn>
            </v-toolbar>

            <v-divider></v-divider>
            <v-card-text class="pa-0">
              <v-data-table
                :headers="complex.headers"
                :search="search"
                :items="mitralist"
                :rows-per-page-items="[10,25,50,{text:'All','value':-1}]"
                class="elevation-1"
                item-key="id"
                select-all
                :loading="loading"
                v-model="complex.selected"
              >
                <v-progress-linear v-slot:progress color="blue" indeterminate></v-progress-linear>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import moment from "moment";
export default {
  data: () => ({
    state_add: false,
    search: "",
    valid: false,
    core_engine: [
      {
        aktif: 1,
        text: "OTHER"
      },
      {
        aktif: 0,
        text: "IRS"
      }
    ],
    select_member_type: [
      {
        aktif: 1,
        text: "Premium"
      },
      {
        aktif: 0,
        text: "Regular"
      }
    ],
    statuses: [
      {
        aktif: 1,
        text: "Aktif"
      },
      {
        aktif: 0,
        text: "Non-Aktif"
      }
    ],
    complex: {
      selected: [],
      headers: [
        {
          text: "Nama Mitra",
          value: "name"
        },
        {
          text: "Alamat",
          value: "address"
        },
        {
          text: "Contact",
          value: "contact"
        },
        {
          text: "Phone",
          value: "phone"
        },
        {
          text: "Email",
          value: "email"
        },
        {
          text: "Member Type",
          value: "server_id"
        },
        {
          text: "Engine Core",
          value: "engine_core",
          width: "30"
        },
        {
          text: "Status",
          value: "status",
          width: "30"
        },
        {
          text: "UpdatedAt",
          value: "update_at"
        },
        {
          text: "Action",
          value: ""
        }
      ],
      items: []
    },
    addApp: {
      name: "",
      address: "",
      contact: "",
      phone: "",
      email: "",
      server_key: "",
      server_id: "",
      member_type: 0,
      engine_core: 0,
      status: 1
    }
  }),
  created() {
    // this.getApplist();
  },
  mounted() {
    this.getmitra();
  },
  computed: {
    ...mapState("AdminMitraModule", ["mitralist", "dialog", "loading"])
  },
  methods: {
    ...mapActions({
      logout: "account/logout",
      AddNew: "AdminMitraModule/AddNewMitra",
      closeDialog: "AdminMitraModule/closeDialog",
      OpenDialogForm: "AdminMitraModule/OpenDialogForm",
      getmitra: "AdminMitraModule/getMitralist"
    }),
    closeForm() {
      if (this.state_add) {
        this.addApp.name = "";
        this.addApp.address = "";
        this.addApp.contact = "";
        this.addApp.phone = "";
        this.addApp.email = "";
        this.addApp.server_key = "";
        this.addApp.server_id = "";
        this.addApp.member_type = "";
        this.addApp.engine_core = "";
        this.addApp.status = "";
      }
      this.closeDialog();
      this.getmitra();
    },
    OpenFormEdit(data) {
      this.addApp = data;
      this.state_add = false;
      this.OpenDialogForm();
    },
    openmodal() {
      this.state_add = true;
      this.OpenDialogForm();
    },
    simpanForm(data) {
      if (this.state_add) {
        this.AddNew(data);
      } else {
        this.AddNew(data);
      }
      this.state_add = false;
      this.getmitra();
    },
    formatDate(value) {
      return moment(String(value)).format("DD/MM/YYYY HH:mm:ss");
    },
    statusformat(value) {
      let a = "Non-Active";
      if (value == 1) {
        a = "Active";
      }
      return a;
    }
  }
};
</script>

<style lang="stylus" scoped>
table.v-table tbody td {
  padding: 0px 0px 0px 5px;
}
</style>
